import { render, staticRenderFns } from "./ResponsableNamesColumn.vue?vue&type=template&id=445a2a1d&functional=true"
import script from "./ResponsableNamesColumn.vue?vue&type=script&lang=js"
export * from "./ResponsableNamesColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports